/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_DescriptionInputs */



/**
* | output |
* | --- |
* | "This recovery code allows you to regain access to your account if you lose your primary authentication method." |
*
* @param {Auth_Recovery_Code_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_description = /** @type {((inputs?: Auth_Recovery_Code_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit diesem Wiederherstellungscode kannst du auf dein Konto zugreifen, wenn du deine primäre Authentifizierungsmethode verlierst.")
	return /** @type {LocalizedString} */ ("This recovery code allows you to regain access to your account if you lose your primary authentication method.")
});